<template>
  <div class="row pt-5 pb-4 px-5 mx-auto m-4 shadow w-100 border-radius">
    <div class="row mx-auto">
      <div class="col-3 p-2">
        <img class="w-100 align-middle" src="/img/profileIcons/targetIcon.png" />
      </div>
      <div class="col-9">
        <h5 class="p-0 m-0">Goal getter</h5>
        <p><small>Every day you reach a performance of 90% or more you gain 50 points.</small></p>
      </div>
    </div>

    <div class="w-100 mx-auto">
      <p class="mb-0">LEVEL 3</p>
      <div class="progress border-0">
        <div
          class="progress-bar rounded"
          role="progressbar"
          style="width: 45%"
          aria-valuenow="45"
          aria-valuemin="0"
          aria-valuemax="100"
        ></div>
      </div>
      <p class="p-0 m-0"><small>230 points to level 4</small></p>
    </div>

  </div>
</template>

<script>
export default {
  mixins: [],
  props: ["user"],
  components: {},

  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
@import "./src/assets/scss/components/engagement/_EmployeeProfile.scss";
</style>